<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'approval.summary'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="backToList()">{{
      'button.back' | transloco
    }}</htx-button>
    @let useCaseDetails = useCaseDetails$ | async;
    @let userDetails = userDetails$ | async;
    @let organisationDetails = organisationDetails$ | async;
    <div class="panel">
      <htx-data-display
        [title]="'useCaseParticipation.detail.useCaseInfo' | transloco"
        [icon]="'lightbulb'"
        [data]="useCaseDetails ?? []"
        [loading]="useCaseDetails === null"
      ></htx-data-display>

      <div class="details-grid">
        <htx-data-display
          [title]="t('userDetails')"
          [icon]="'person'"
          [data]="userDetails ?? []"
          [loading]="userDetails === null"
        ></htx-data-display>
        <htx-data-display
          [title]="t('organisationDetails')"
          [icon]="'business'"
          [data]="organisationDetails ?? []"
          [loading]="organisationDetails === null"
        ></htx-data-display>
      </div>

      <htx-data-container [title]="t('decision')" [icon]="'done_all'">
        <app-admission-decision
          [approvalForm]="approvalForm"
          [admissionState$]="admissionState$"
          [existingReasoning$]="existingReasoning$"
          (approve)="approve()"
          (reject)="reject()"
        ></app-admission-decision>
      </htx-data-container>

      <htx-data-container [title]="t('comments')" [icon]="'chat'">
        <app-comments
          [comments]="(commentsForBox$ | async) ?? []"
          [hasMore]="(hasMoreComments$ | async) ?? false"
          [placeholder]="t('newComment.placeholder')"
          (commentAdded)="onCommentAdded($event)"
          (loadMore)="loadMoreComments()"
        ></app-comments>
      </htx-data-container>
    </div>
  </div>
</app-protected-content>
